export enum PaymentRoutesEnum {
  PAYMENT_INTENTION = 'SpreeMarketplace',
  PAYMENT_INTENTION_NEW_CART = 'Marketplace',
  REVALIDATE_DEBIT = 'WalletRoute',
  LA_NAVE = 'LaNave',
  GIFT_CARDS = 'KtpGiftCards',
  CUBACEL = 'CubacelTopUps',
  EMAIL_PAYMENT_REQUEST = 'UserPaymentRequest'
}
